import { useState } from 'react'

const useCsvDownloadSectionOpen = () => {
  const [isCsvCriteriaOpen, setIsCsvCriteriaOpen] = useState(false)
  const toggleCsvCriteriaOpen = () => setIsCsvCriteriaOpen(!isCsvCriteriaOpen)
  return [isCsvCriteriaOpen, toggleCsvCriteriaOpen] as [boolean, () => boolean]
}

export default useCsvDownloadSectionOpen
